// extracted by mini-css-extract-plugin
export var active = "_dk-7";
export var container = "_dk-0";
export var evenWidth = "_dk-4";
export var large = "_dk-5";
export var outlet = "_dk-8";
export var slide = "_dk-2";
export var small = "_dk-6";
export var tab = "_dk-3";
export var tabs = "_dk-1";